import type { ResourceSpecifier } from './ast';

// these resources can be added to a view, but are not required to be
const optionalViewScopedResources = ['flag', 'feature', 'segment', 'aiconfig'] as const satisfies Array<
  ResourceSpecifier['type']
>;

export type OptionalViewScopedResource = Extract<
  ResourceSpecifier,
  { type: (typeof optionalViewScopedResources)[number] }
>;

export const isOptionalViewScopedResourceType = (resourceType: ResourceSpecifier['type']) =>
  (optionalViewScopedResources as readonly string[]).includes(resourceType);

export const isOptionalViewScopedResource = (resource: ResourceSpecifier): resource is OptionalViewScopedResource =>
  isOptionalViewScopedResourceType(resource.type);
